import { DocumentNode, gql, useMutation } from '@apollo/client';
import { ClaimantInput } from '../gql/graphql';
import { GET_CLAIM } from './claim.query';

export const UPSERT_CLAIM_CONTACTS = gql`
  mutation UpsertClaimContacts($claimUuid: String!, $details: ClaimantInput!) {
    upsertClaimContacts(claimUuid: $claimUuid, details: $details) {
      uuid
      referenceId
    }
  }
`;

export function useUpsertClaimContactsMutation() {
  const [upsertClaimContactsMutation, { loading, error, data }] = useMutation(
    UPSERT_CLAIM_CONTACTS as DocumentNode,
    {
      refetchQueries: [GET_CLAIM],
      awaitRefetchQueries: true,
    }
  );

  const upsertClaimContacts = async (
    claimUuid: string,
    details: ClaimantInput
  ) => {
    const response = await upsertClaimContactsMutation({
      variables: {
        claimUuid,
        details,
      },
    });
    return response.data?.upsertClaimContacts;
  };

  return {
    upsertClaimContacts,
    loading,
    error,
    data,
  };
}
